module.exports = __webpack_public_path__ + "img/process-2.c8a86592.png";